/*
 *
 * ConfirmProfile constants
 *
 */

// LOAD
export const LOAD_CONFIRMPROFILE = 'app/ConfirmProfile/LOAD_CONFIRMPROFILE';
export const LOAD_CONFIRMPROFILE_SUCCESS =
  'app/ConfirmProfile/LOAD_CONFIRMPROFILE_SUCCESS';
export const LOAD_CONFIRMPROFILE_ERROR =
  'app/ConfirmProfile/LOAD_CONFIRMPROFILE_ERROR';

// CHANGE/UPDATE
export const CHANGE_CONFIRMPROFILE = 'app/ConfirmProfile/CHANGE_CONFIRMPROFILE';
export const CHANGE_CONFIRMPROFILE_SUCCESS =
  'app/ConfirmProfile/CHANGE_CONFIRMPROFILE_SUCCESS';
export const CHANGE_CONFIRMPROFILE_ERROR =
  'app/ConfirmProfile/CHANGE_CONFIRMPROFILE_ERROR';

// DELETE
export const DELETE_CONFIRMPROFILE = 'app/ConfirmProfile/DELETE_CONFIRMPROFILE';
export const DELETE_CONFIRMPROFILE_SUCCESS =
  'app/ConfirmProfile/DELETE_CONFIRMPROFILE_SUCCESS';
export const DELETE_CONFIRMPROFILE_ERROR =
  'app/ConfirmProfile/DELETE_CONFIRMPROFILE_ERROR';

export const FLUSH_STATE_CONFIRMPROFILE =
  'app/ConfirmProfile/FLUSH_STATE_CONFIRMPROFILE';
